const PROFILE_PATH = /^\/in\/([^/?#]+)\/?$/i;
const MEMBER_ID = /^(?=.*\d)[a-z0-9]{5,}$/i;
const LOWER_PARTICLES = new Set(['o', 'de', 'da', 'di', 'van', 'von', 'der', 'den', 'del', 'la', 'le', 'du']);
const UPPER_TOKENS = new Set(['mbe', 'obe', 'cbe', 'kbe', 'dbe', 'bem', 'phd', 'mba', 'md', 'qc', 'kc', 'jr', 'sr']);

function formatNamePart(part, index) {
    const lower = part.toLowerCase();
    if (UPPER_TOKENS.has(lower)) return lower.toUpperCase();
    if (index > 0 && LOWER_PARTICLES.has(lower)) return lower;
    return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/**
 * Name encoded in a LinkedIn person profile URL.
 * https://www.linkedin.com/in/peter-o-hara-mbe-25418a6/ → "Peter o Hara MBE"
 * Returns an empty string when the value is not a /in/ profile URL.
 */
export function linkedInProfileName(value) {
    const text = String(value || '').trim();
    if (!text) return '';
    let url;
    try {
        url = new URL(text);
    } catch {
        return '';
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
    if (!/(^|\.)linkedin\.com$/i.test(url.hostname)) return '';
    const match = url.pathname.match(PROFILE_PATH);
    if (!match) return '';

    let parts;
    try {
        parts = decodeURIComponent(match[1]).split('-').filter(Boolean);
    } catch {
        return '';
    }
    if (!parts.length) return '';
    const publicId = parts[parts.length - 1];
    if (parts.length > 1 && MEMBER_ID.test(publicId)) {
        parts = parts.slice(0, -1);
    }
    if (!parts.length) return '';
    return parts.map(formatNamePart).join(' ');
}
